module.exports = __webpack_public_path__ + "static/media/renewalBanner.09c49101.jpg";